import { render, staticRenderFns } from "./stationCapacity.vue?vue&type=template&id=50589ea4&scoped=true"
import script from "./stationCapacity.vue?vue&type=script&lang=ts"
export * from "./stationCapacity.vue?vue&type=script&lang=ts"
import style0 from "./stationCapacity.vue?vue&type=style&index=0&id=50589ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50589ea4",
  null
  
)

export default component.exports